import { Arrival } from '../../services/arrival.service'
import router from '../../router'
import {Booking, BookingOption, BookingService} from "@/services/booking.service";
import {GOSservice} from "@/services/GOS.service"
import {KeycloakService} from "@/services/keycloak.service";
import {Constants} from "@/constants";
import InputButton from "@/components/input-button/InputButton.vue";

export default {
    name: 'ArrivalCard',
    components: {
        InputButton

    },

    data () {
        return {
            displayOption: BookingOption,
            booking: Booking,
            moving: false,
            showTiming: false,
            showHandling: false,
        }
    },

    props: {
        arrival: Arrival,
        expected: Boolean,
        arrived: Boolean,
        delayed: Boolean,
        onDock: Boolean,
        offDock: Boolean,
        handling: Boolean,
        departed: Boolean
    },

    mounted() {
        this.showHandling = process.env.VUE_APP_HIDE_HANDLING === 'false'
        this.getArrivalsDisplayBookingOption()

    },
    computed: {
        isBookingAgent() {
            return KeycloakService.isBookingAgent()
        }
    },

    methods: {
        selectArrival() {
            if(!this.moving) {
                router.push(`/booking/${this.arrival.bookingId}`)
            }
        },

        getArrivalsDisplayBookingOption: async function() {
            try {
                this.booking = await BookingService.getBooking(this.arrival.bookingId)
                let options = this.booking.options
                this.displayOption = options.filter(o => o.usedForArrivalsDisplay == true)[0]
            } catch (error) {}

        },

        handleResponse(response) {
            //When mutating an "arrived" booking, give an alert on succes
            if(this.arrived){
                this.$store.dispatch(Constants.STORE_ACTION_CREATE_ALERT, {code: response.status, message: "Arrival set to departed succesfully"})
            }
            //reload the parent to refresh the page
            this.$parent.reload()
        },

        handleError(error) {
            //format error message
            let errorString = "Error code : " +error.errorCode
            errorString = error.message.errorAtEntry? errorString + "\n Error ocurred regarding "
                + error.message.errorAtEntry : errorString+ error.message

            //display error card
            this.$store.dispatch(Constants.STORE_ACTION_CREATE_ALERT, {code: error.errorCode, message: errorString})
        },

        /**
         * Function that adds a vehicleArrivalDate for arrivals that are expected or delayed,
         * or a vehicleDepartureDate for "arrived" arrivals
         *
         * Allows the user to manually move arrivals to another column by clicking the button in the header
         */
        setDate: async function(){
            //check whether we need to add departure or arrival date
            if (this.arrived){
                await GOSservice.setDepartureDate(this.booking)
                    .then((response) => {
                        this.handleResponse(response)
                     })
                    .catch((error) => {
                        this.handleError(error)
                    })
            } else {
                await GOSservice.setArrivalDate(this.booking)
                    .then((response) => {
                        this.handleResponse(response)
                    })
                    .catch((error) => {
                        this.handleError(error)
                    })
            }
        },

        determineActions() {
            if (this.expected) {
                return ["Arrive"]
            } else if (this.arrived) {
                const options =  ['Expect', "Depart"]
                if (this.booking.dockArrivalDate && this.booking.dockDepartureDate == undefined) {
                    options.push('Off Dock')
                } else if (this.booking.dockArrivalDate == undefined && this.booking.dockDepartureDate == null)  {
                    options.push('On Dock')
                }
                return options
            } else if (this.onDock) {
                const options =  ['Off Dock']
                if (this.booking.startHandlingDate == undefined && this.booking.stopHandlingDate == undefined && this.showHandling) {
                    options.push('Start Handling')
                }
                return options
            } else if (this.handling) {
                const options =  []
                if (this.booking.startHandlingDate && this.booking.stopHandlingDate == undefined && this.showHandling) {
                    options.push('Stop Handling')
                }
                return options
            } else if (this.delayed) {
                return ["Arrive"]
            } else if (this.departed) {
                return ["Arrive"]
            } else if (this.offDock) {
                return ['Depart']
            }
        },

        async performAction (action) {
            let bookingChanged = true
            switch (action) {
                case "Expect":
                    this.booking.vehicleArrivalDate = null
                    this.booking.vehicleDepartureDate = null
                    this.booking.dockArrivalDate = null
                    this.booking.dockDepartureDate = null
                    this.booking.startHandlingDate = null
                    this.booking.stopHandlingDate = null
                    break
                case "Arrive":
                    this.booking.vehicleArrivalDate = new Date().toISOString()
                    this.booking.vehicleDepartureDate = null
                    this.booking.dockArrivalDate = null
                    this.booking.dockDepartureDate = null
                    this.booking.startHandlingDate = null
                    this.booking.stopHandlingDate = null
                    break
                case "Depart":
                    this.booking.vehicleDepartureDate = new Date().toISOString()
                    break
                case "On Dock":
                    this.booking.vehicleDepartDate = null
                    this.booking.dockArrivalDate = new Date().toISOString()
                    this.booking.dockDepartureDate = null
                    this.booking.startHandlingDate = null
                    this.booking.stopHandlingDate = null
                    break
                case "Off Dock":
                    this.booking.vehicleDepartDate = null
                    this.booking.dockDepartureDate = new Date().toISOString()
                    break
                case "Start Handling":
                    this.booking.vehicleDepartDate = null
                    this.booking.dockDepartureDate = null
                    this.booking.startHandlingDate = new Date().toISOString()
                    this.booking.stopHandlingDate = null
                    break
                case "Stop Handling":
                    this.booking.vehicleDepartDate = null
                    this.booking.stopHandlingDate = new Date().toISOString()
                    break
                default:
                    bookingChanged = false
                    break
            }

            if(bookingChanged) {
                await GOSservice.updateGOSBooking(this.booking) .then((response) => {
                    this.handleResponse(response)
                })
                    .catch((error) => {
                        this.handleError(error)
                    })
            }




        },

        displayTime(date) {
            return date ? new Date(date).toLocaleTimeString() : "-"
        }
    },



}
